import HeroSection from "../components/Landing/Hero-section.jsx";
import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../hooks/useAuth";
import OurServices from "../components/Landing/OurServices.jsx";
import Footer from "../components/Landing/footer.jsx";
// import "../styles/landing-styles.css";
import "../styles/global.css";
import "../styles/landing-page.css";
import useRestoreScroll from "../hooks/useRestoreScroll.js";

const LandingPage = () => {
  const { t, i18n } = useTranslation();
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const isRTL = i18n.dir && i18n.dir() === "rtl";
  useRestoreScroll();

  // Ensure body overflow is restored when component mounts (fix for scroll issues)
  useEffect(() => {
    // Restore body overflow on mount
    document.body.style.overflow = '';
    document.body.style.overflowY = '';

    // Cleanup: ensure overflow is restored on unmount
    return () => {
      document.body.style.overflow = '';
      document.body.style.overflowY = '';
    };
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);
  return (
    <div className="landing-page">
      <HeroSection />
      {/* Three Experiences Section */}
      <section className="experiences-section">
        <div className="experiences-container">
          <h2 className="experiences-title">{t('ourServices.title')}</h2>
          <p className="experiences-desc">
            {t('ourServices.subtitle')}
          </p>
          <div className="experiences-cards-row">
            {/* Connect Card */}
            <div className="experiences-card connect-card">
              <img
                src="/images/Sulhafa-Community.png"
                alt="Sulhafa Connect Mascot"
                className="experiences-mascot"
              />
              <h3 className="experiences-card-title">{t('ourServices.cards.connect.title')}</h3>
              <p className="experiences-card-desc">
                {t('ourServices.cards.connect.body')}
              </p>
              <Link to="/sulhafa-connect" className="experiences-btn connect">
                {t('ourServices.cards.more')} <span className="experiences-btn-arrow">→</span>
              </Link>
            </div>
            {/* Care Card */}
            <div className="experiences-card care-card">
              <img
                src="/images/Sulhafa-Vet.png"
                alt="Sulhafa Care Mascot"
                className="experiences-mascot"
              />
              <h3 className="experiences-card-title">{t('ourServices.cards.care.title')}</h3>
              <p className="experiences-card-desc">
                {t('ourServices.cards.care.body')}
              </p>
              <Link to="/sulhafa-care" className="experiences-btn care">
                {t('ourServices.cards.more')} <span className="experiences-btn-arrow">→</span>
              </Link>
            </div>
            {/* Shop Card */}
            <div className="experiences-card shop-card">
              <img
                src="/images/Sulhafa-Shopping.png"
                alt="Sulhafa Shop Mascot"
                className="experiences-mascot"
              />
              <h3 className="experiences-card-title">{t('ourServices.cards.shop.title')}</h3>
              <p className="experiences-card-desc">
                {t('ourServices.cards.shop.body')}
              </p>
              <button className="experiences-btn shop" disabled style={{ cursor: 'default', opacity: 0.7, pointerEvents: 'none' }}>
                {t('comingSoon')}
              </button>
            </div>
          </div>
        </div>
      </section>
      {/* Choose Your Journey Section */}
      <section className="choose-journey-section">
        <h2 className="choose-journey-title">{t('hero.getStarted.title')}</h2>
        <p className="choose-journey-subtitle">
          {t('hero.journey.subtitle')}
        </p>
        <div className="choose-journey-cards-row">
          {/* Pet Guardian Card */}
          <div className="choose-journey-card guardian">
            <img
              src="/images/petguardian.png"
              alt={t("hero.alt.petGuardian")}
              className="choose-journey-img"
              style={{ transform: isRTL ? "scaleX(-1)" : "none" }}
            />
            <div className="choose-journey-role">{t('hero.roles.petGuardian')}</div>
            <button
              className="choose-journey-btn"
              aria-label={isAuthenticated ? t('header.connect') : t('hero.cta')}
              onClick={() => {
                if (!isAuthenticated) return navigate("/auth/register/pet_guardian");
                const userType = userDataService.getUserType();
                if (userType === 'ADMIN' || userType === 'CONTENT_ADMIN') {
                  return navigate(userDataService.getDefaultRedirect());
                }
                navigate("/social");
              }}
            >
              {isAuthenticated ? t('header.connect') : t('hero.cta')}
            </button>
          </div>
          {/* Veterinarian Card */}
          <div className="choose-journey-card vet">
            <img
              src="/images/veterinarian-1.png"
              alt={t("hero.alt.veterinarian")}
              className="choose-journey-img"
              style={{ transform: isRTL ? "scaleX(-1)" : "none" }}
            />
            <div className="choose-journey-role">{t('hero.roles.veterinarian')}</div>
            <button
              className="choose-journey-btn"
              aria-label={isAuthenticated ? t('header.connect') : t('hero.cta')}
              onClick={() => {
                if (!isAuthenticated) return navigate("/auth/register/veterinarian");
                const userType = userDataService.getUserType();
                if (userType === 'ADMIN' || userType === 'CONTENT_ADMIN') {
                  return navigate(userDataService.getDefaultRedirect());
                }
                navigate("/social");
              }}
            >
              {isAuthenticated ? t('header.connect') : t('hero.cta')}
            </button>
          </div>
          {/* Service Provider Card */}
          <div className="choose-journey-card service">
            <img
              src="/images/provider.png"
              alt={t('hero.roles.serviceProvider')}
              className="choose-journey-img"
              style={{ transform: isRTL ? "scaleX(-1)" : "none" }}
            />
            <div className="choose-journey-role">{t('hero.roles.serviceProvider')}</div>
            <button
              className="choose-journey-btn"
              disabled
              style={{ cursor: 'default', opacity: 0.7, pointerEvents: 'none' }}
            >
              {t('comingSoon')}
            </button>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default LandingPage;
